import { render, staticRenderFns } from "./CopyTerm.vue?vue&type=template&id=62f42b51"
import script from "./CopyTerm.vue?vue&type=script&lang=js"
export * from "./CopyTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports